import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarLessonV2Request } from './get-grammar-lesson-v2-request';
import { getGrammarLessonV2RequestSchema } from './get-grammar-lesson-v2-request';
import type { IGetGrammarLessonV2Response } from './get-grammar-lesson-v2-response';
import { getGrammarLessonV2ResponseSchema } from './get-grammar-lesson-v2-response';

export async function getGrammarLessonV2Api(
  request: IGetGrammarLessonV2Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarLessonV2Response>> {
  const { slug } = getGrammarLessonV2RequestSchema.parse(request);
  return getRequest<IGetGrammarLessonV2Response>({
    path: `/grammar/lesson/${encodeURIComponent(slug)}/v2`,
    schema: getGrammarLessonV2ResponseSchema,
    options,
  });
}
